import { axios } from "~/plugins/request"

export const state = () => {
	return {}
}
export const mutations = {}
export const actions = {
	findEnrolment({ commit }, params) {
		return new Promise((resolve, reject) => {
			axios.post(`enrolment/findEnrolment`, params)
				.then(response => {
					resolve(response)
				})
				.catch(error => {
					reject(error)
				})
		})
  },
  channelBack({ commit }, params) {
		return new Promise((resolve, reject) => {
			axios.get(`enrolment/channelBack`, {params})
				.then(response => {
					resolve(response)
				})
				.catch(error => {
					reject(error)
				})
		})
  },
  channelVia({ commit }, params) {
		return new Promise((resolve, reject) => {
			axios.get(`enrolment/channelVia`, {params})
				.then(response => {
					resolve(response)
				})
				.catch(error => {
					reject(error)
				})
		})
  },
  channelReduction({ commit }, params) {
		return new Promise((resolve, reject) => {
			axios.get(`enrolment/channelReduction`, {params})
				.then(response => {
					resolve(response)
				})
				.catch(error => {
					reject(error)
				})
		})
  },
  findEnrolmentStatus({ commit }, params) {
		return new Promise((resolve, reject) => {
			axios.get(`enrolment/findEnrolmentStatus`, {params})
				.then(response => {
					resolve(response)
				})
				.catch(error => {
					reject(error)
				})
		})
  },
}